import React from 'react';
import '../../styles/shared.css';
import './CalendarPage.css';

const CalendarPage: React.FC = () => {
  return (
    <div className="page-container calendar-page">
      <div className="page-header">
        <div className="header-content">
          <h1>课程日历</h1>
        </div>
      </div>
      
      <div className="content-container">
        <div className="calendar-content">
          <div className="calendar-view">
            <div className="month-selector">
              <button className="btn btn-outline nav-btn">&lt;</button>
              <span className="current-month">2025年7月</span>
              <button className="btn btn-outline nav-btn">&gt;</button>
            </div>
            
            <div className="weekdays">
              <div>日</div>
              <div>一</div>
              <div>二</div>
              <div>三</div>
              <div>四</div>
              <div>五</div>
              <div>六</div>
            </div>
            
            <div className="calendar-grid">
              <div className="calendar-day other-month">
                <div className="day-number">29</div>
              </div>
              <div className="calendar-day other-month">
                <div className="day-number">30</div>
              </div>
              <div className="calendar-day other-month">
                <div className="day-number">31</div>
              </div>
              <div className="calendar-day">
                <div className="day-number">1</div>
                <div className="course-indicator">2课</div>
              </div>
              <div className="calendar-day">
                <div className="day-number">2</div>
              </div>
              <div className="calendar-day today">
                <div className="day-number">3</div>
                <div className="course-indicator">1课</div>
              </div>
              <div className="calendar-day">
                <div className="day-number">4</div>
              </div>
              <div className="calendar-day">
                <div className="day-number">5</div>
                <div className="course-indicator">1课</div>
              </div>
              <div className="calendar-day">
                <div className="day-number">6</div>
              </div>
              <div className="calendar-day">
                <div className="day-number">7</div>
              </div>
              <div className="calendar-day has-course">
                <div className="day-number">8</div>
                <div className="course-indicator">3课</div>
              </div>
              {/* More calendar days... */}
            </div>
          </div>
          
          <div className="course-schedule">
            <h3>今日课程安排</h3>
            <div className="schedule-list">
              <div className="schedule-item">
                <div className="schedule-time">14:00-15:30</div>
                <div className="course-info">
                  <div className="course-name">六年级数学</div>
                  <div className="teacher">张老师</div>
                  <div className="location online">在线教室</div>
                </div>
              </div>
              
              <div className="schedule-item">
                <div className="schedule-time">16:00-17:30</div>
                <div className="course-info">
                  <div className="course-name">五年级语文</div>
                  <div className="teacher">李老师</div>
                  <div className="location online">在线教室</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;